import React from 'react';
import {styles} from './listMetaContainer_styles.web';
import {ListMetaContainerProps} from './listMetaContainer_types.web';
import InfoIcon from '../../Icons/icons/info';
import {useTheme} from '../../../../utils/theming/themeProvider';
import Chip from '../../Chips/Chip/Chip.web';
import ActionItems from '../../Action/ActionItems/actionItems.web';
import Tooltip from '../../Tooltips/Tooltip/Tooltip.web';

const ListMetaContainer = (
  props: React.PropsWithChildren<ListMetaContainerProps>,
) => {
  // Props
  const {
    id,
    className,
    condition = 'all',
    size = 'medium',
    align = 'left',
    infoColor,
    color,
    tooltip,
    chip,
    actionItem,
    title,
    content,
    extraInfo,
    containerStyle,
  } = props;

  // Styles
  const {colors, fontStyles} = useTheme();
  const titleColor =
    color === 'gray'
      ? colors.neutral700
      : color === 'red'
      ? colors.alert300
      : color === 'white'
      ? colors.neutral100
      : colors.neutral1000;
  const infoFinalColor = infoColor || color;
  const textAlignment = align || 'left';
  const mainTextsFontSize = size === 'medium' ? 'MD' : 'SM';
  const extraTextFontSize = size === 'medium' ? 'SM' : 'XS';
  const generalStyles = styles();

  return (
    <div
      id={id}
      className={className}
      style={{
        ...generalStyles.listMetaContainerContainer,
        alignItems: align === 'left' ? 'flex-start' : 'flex-end',
        ...containerStyle,
      }}>
      <div style={{...generalStyles.listMetaContainerTextsContainer}}>
        {title?.length ? (
          <div style={{...generalStyles.listMetaContainerTitleContainer}}>
            <p
              style={{
                textAlign: textAlignment,
                color: titleColor,
                ...fontStyles['button' + mainTextsFontSize],
                lineHeight:
                  fontStyles['button' + extraTextFontSize]?.lineHeight + 'px',
                margin: 0,
              }}>
              {title}
            </p>
            {tooltip && (
              <Tooltip {...tooltip}>
                <InfoIcon
                  size={'16'}
                  color={
                    color === 'red'
                      ? colors.alert300
                      : color === 'white'
                      ? colors.neutral100
                      : colors.neutral700
                  }
                />
              </Tooltip>
            )}
          </div>
        ) : null}
        {content?.length && condition === 'all' ? (
          <p
            style={{
              textAlign: textAlignment,
              color:
                color === 'red'
                  ? colors.alert300
                  : color === 'white'
                  ? colors.neutral100
                  : colors.neutral1000,
              ...fontStyles['bodyBold' + mainTextsFontSize],
              lineHeight:
                fontStyles['bodyBold' + extraTextFontSize]?.lineHeight + 'px',
              margin: 0,
            }}>
            {content}
          </p>
        ) : null}
        {extraInfo?.length && condition !== 'title' ? (
          <p
            style={{
              textAlign: textAlignment,
              color:
                infoFinalColor === 'red'
                  ? colors.alert300
                  : infoFinalColor === 'white'
                  ? colors.neutral100
                  : colors.neutral700,
              ...fontStyles['bodyRegular' + extraTextFontSize],
              lineHeight:
                fontStyles['bodyRegular' + extraTextFontSize]?.lineHeight +
                'px',
              margin: 0,
            }}>
            {extraInfo}
          </p>
        ) : null}
      </div>
      {chip ? (
        <Chip
          {...chip}
          style={chip?.style || 'filled'}
          color={chip?.color || 'yellow'}
          form={chip?.form || 'square'}
          chipSize={chip?.chipSize || 'large'}
        />
      ) : null}
      {actionItem ? (
        <ActionItems
          {...actionItem}
          color={actionItem?.color || 'black'}
          leading={actionItem?.leading || 'image'}
          leadingAlign={actionItem?.leadingAlign || 'left'}
        />
      ) : null}
    </div>
  );
};

export default ListMetaContainer;
